let url = ''

const urlMap = {
    // 10环境域名: carsale10.51gofunev.com
    // 20环境域名: carsale20.51gofunev.com
    // pre环境域名: precarsale.shouqiev.com
    // 正式域名: carsale.shouqiev.com
    '//app5.shouqiev.com': 'https://carsale.shouqiev.com', // app5线上
    '//gateway.shouqiev.com': 'https://carsale.shouqiev.com', // 线上
    '//pre': 'https://precarsale.shouqiev.com',// app5预发布
    '//app510': 'https://carsale10.51gofunev.com', // app5 10环境
    '//app520': 'https://carsale20.51gofunev.com', // app5 20环境
    '//test-app5': 'https://test-carsale.shouqiev.com', // app5 20环境
    ':8802': 'https://carsale10.51gofunev.com', // 本地测试
    // ':8802': 'https://precarsale.shouqiev.com'
    // 不支持http
}

const pageUrl = location.href

for (name in urlMap) {
    if (pageUrl.indexOf(name) > -1) {
        url = urlMap[name]
        break;
    }
}
export default url



// WEBPACK FOOTER //
// src/pages/saleCar/server-config.js